import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import DropdownMenu, { Menu } from "@/components/dropdown-menu";
import SiteLogo from "@/components/site-logo";

export default () => {
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf("android") > -1;
  const openExternalLink = (url: string) => () =>
    window.open(url, "_blank", "noopener,noreferrer");

  const menu: Menu = [
    {
      text: (
        <div className="flex items-center">
          <svg
            viewBox="0 0 384 512"
            width="16"
            className="mr-2 text-gray-700 dark:text-gray-500"
          >
            <path
              fill="currentColor"
              d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
            />
          </svg>
          <span>App Store</span>
        </div>
      ),
      action: openExternalLink(
        "https://apps.apple.com/app/apple-store/id1586018825?pt=123469648&ct=TruthSocial.com&mt=8",
      ),
      href: "https://apps.apple.com/app/apple-store/id1586018825?pt=123469648&ct=TruthSocial.com&mt=8",
      target: "_blank",
    },
    {
      text: (
        <div className="flex items-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 34 34"
            fill="currentColor"
            className="mr-2 text-gray-700 dark:text-gray-500"
          >
            <path d="M0.798828 16.741C0.798828 7.74655 8.11642 0.428955 17.1109 0.428955C20.7435 0.428955 24.1818 1.59768 27.0541 3.80882L23.2635 8.73289C21.4875 7.36578 19.3599 6.64308 17.1109 6.64308C11.5429 6.64308 7.01295 11.173 7.01295 16.741C7.01295 22.309 11.5429 26.839 17.1109 26.839C21.5955 26.839 25.4064 23.9008 26.7198 19.8481H17.1109V13.634H33.423V16.741C33.423 25.7355 26.1054 33.0531 17.1109 33.0531C8.11642 33.0531 0.798828 25.7355 0.798828 16.741Z" />
          </svg>
          <span>Play Store</span>
        </div>
      ),
      action: openExternalLink(
        "https://play.google.com/store/apps/details?id=com.truthsocial.android.app",
      ),
      href: "https://play.google.com/store/apps/details?id=com.truthsocial.android.app",
      target: "_blank",
    },
    {
      text: (
        <div className="flex items-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            className="mr-2 text-gray-700 dark:text-gray-500"
          >
            <g clipPath="url(#clip0_2064_130457)">
              <path
                d="M9.42943 5.63466L9.46776 5.78159H6.74626L6.78459 5.63466C6.78459 4.90317 7.37872 4.31224 8.10701 4.31224C8.8353 4.31224 9.42943 4.90317 9.42943 5.63466ZM15.9968 6.14254V9.85426C15.9968 13.2338 13.2306 15.9968 9.85426 15.9968H6.14254C2.76622 16 0 13.2338 0 9.85426V6.14254C0 2.76622 2.76622 0 6.14254 0H9.85426C13.2338 0 15.9968 2.76622 15.9968 6.14254ZM12.4001 5.76882L10.4867 5.78159L10.4516 5.63466C10.4037 4.33779 9.31443 3.32841 8.01757 3.37632C6.78778 3.42104 5.80395 4.40807 5.75923 5.63466L5.7241 5.78159H3.80755L4.32182 10.6113C4.42723 11.5919 5.25135 12.3394 6.23837 12.3426H9.96287C10.9499 12.3394 11.774 11.5919 11.8794 10.6113L12.4001 5.76882Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_2064_130457">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Galaxy Store</span>
        </div>
      ),
      action: openExternalLink(
        "https://galaxystore.samsung.com/detail/com.truthsocial.android.app",
      ),
      href: "https://galaxystore.samsung.com/detail/com.truthsocial.android.app",
      target: "_blank",
    },
    ...(isAndroid
      ? [
          null,
          {
            text: (
              <div className="flex items-center">
                <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  className="mr-2 text-gray-700 dark:text-gray-500"
                >
                  <path
                    fill="currentColor"
                    d="M11.9033 3.21722L13.2306 0.918074C13.3055 0.789182 13.2602 0.625455 13.133 0.550559C13.0059 0.475663 12.8404 0.519206 12.7673 0.648098L11.4226 2.97686C10.3967 2.50832 9.24189 2.24705 8 2.24705C6.75811 2.24705 5.60331 2.50832 4.5774 2.97686L3.23275 0.648098C3.15785 0.519206 2.99412 0.475663 2.86523 0.550559C2.73634 0.625455 2.69279 0.789182 2.76769 0.918074L4.09493 3.21722C1.80623 4.45737 0.256041 6.77394 0 9.4859H16C15.744 6.77394 14.1938 4.45737 11.9033 3.21722ZM4.32658 7.239C3.95558 7.239 3.656 6.93767 3.656 6.56841C3.656 6.19741 3.95733 5.89783 4.32658 5.89783C4.69758 5.89783 4.99717 6.19916 4.99717 6.56841C4.99892 6.93767 4.69758 7.239 4.32658 7.239ZM11.6717 7.239C11.3007 7.239 11.0011 6.93767 11.0011 6.56841C11.0011 6.19741 11.3024 5.89783 11.6717 5.89783C12.0427 5.89783 12.3423 6.19916 12.3423 6.56841C12.344 6.93767 12.0427 7.239 11.6717 7.239Z"
                  />
                </svg>
                <span>Android APK</span>
              </div>
            ),
            to: "/sideload",
          },
        ]
      : []),
  ];

  return (
    <header className="mx-auto max-w-6xl px-4 py-10 sm:px-6 xl:px-0">
      <div className="flex items-center justify-between">
        <Link
          key="logo"
          to="/"
          data-preview-title-id="column.home"
          className="flex shrink-0 items-center"
        >
          <SiteLogo alt="Logo" className="h-5 w-auto cursor-pointer" />
          <span className="hidden">
            <FormattedMessage id="tabs_bar.home" defaultMessage="Home" />
          </span>
        </Link>

        <div className="flex items-center space-x-6">
          <DropdownMenu
            items={menu}
            placement="bottom-end"
            width="medium"
            containerClassName="p-1"
          >
            <button
              type="button"
              className="text-muted-foreground hover:underline"
            >
              Download
            </button>
          </DropdownMenu>

          <a
            href="https://help.truthsocial.com"
            className="text-muted-foreground hover:underline"
          >
            Help Center
          </a>
        </div>
      </div>
    </header>
  );
};
